const reviews = [
  {
    name: "阿澈",
    role: "连载漫读者 · 三年",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20friendly%20young%20man%20with%20glasses%2C%20warm%20soft%20lighting%2C%20minimal%20stylized%20illustration%2C%20warm%20neutral%20background&width=200&height=200&seq=avatar-01&orientation=squarish",
    text: "翻页超顺滑，白天上班摸鱼用下拉，晚上躺床上切夜间模式，体验完全不一样，护眼效果是真的明显。",
  },
  {
    name: "苏小满",
    role: "日漫国漫通吃",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20cheerful%20young%20woman%20with%20long%20hair%2C%20warm%20soft%20lighting%2C%20minimal%20stylized%20illustration%2C%20warm%20neutral%20background&width=200&height=200&seq=avatar-02&orientation=squarish",
    text: "离线缓存太香了，通勤地铁信号再差也能一口气看完整话，追更从不错过更新。",
  },
  {
    name: "老许",
    role: "横屏狂魔",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20mature%20man%20with%20short%20beard%2C%20warm%20soft%20lighting%2C%20minimal%20stylized%20illustration%2C%20warm%20neutral%20background&width=200&height=200&seq=avatar-03&orientation=squarish",
    text: "横屏看跨页大场面分镜是真的爽，目录跳转也快，几百话的漫画想回看哪话点一下就到位。",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wide text-primary-500">读者口碑</span>
          <h2 className="mt-2 text-2xl md:text-4xl">百万读者都在这样看</h2>
          <p className="mt-4 text-sm text-foreground-600 md:text-base">
            不同的阅读习惯，在这里都能找到最顺手的方式。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {reviews.map((r) => (
            <figure key={r.name} className="rounded-lg border border-background-200/70 bg-background-50 p-6">
              <div className="flex gap-1 text-primary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-800">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`${r.name}的头像`}
                  title={`${r.name} · 扑飞漫画网读者`}
                  className="h-11 w-11 rounded-full object-cover object-top"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{r.name}</p>
                  <p className="text-xs text-foreground-600">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}